(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["niverto-clarity"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!window.Shopify || window.Shopify.designMode || window.nivertoClarityInitialized) return;
    window.nivertoClarityInitialized = true;
    let loaded = false;
    let withdrawing = false;

    function syncConsent() {
      const privacy = window.Shopify.customerPrivacy;
      if (!privacy || withdrawing) return;
      const allowed = privacy.currentVisitorConsent().analytics === 'yes' && privacy.analyticsProcessingAllowed();

      if (!allowed) {
        if (loaded) {
          withdrawing = true;
          window.clarity('consentv2', { analytics_Storage: 'denied', ad_Storage: 'denied' });
          window.clarity('stop');
          window.location.reload();
        }
        return;
      }

      if (loaded) return;
      loaded = true;
      window.clarity = window.clarity || function () {
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };
      window.clarity('consentv2', { analytics_Storage: 'granted', ad_Storage: 'denied' });
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.clarity.ms/tag/ojj8y5u5la';
      document.head.appendChild(script);
    }

    document.addEventListener('visitorConsentCollected', syncConsent);
    if (window.Shopify.customerPrivacy) {
      syncConsent();
    } else if (typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error) syncConsent();
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
